var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFfm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.720222,0,0,0.978303,3.38817,0.658355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.66,5.046L16.66,0.471L0.623,0.471L0.623,22.744L22.737,22.744L22.737,5.046L16.66,5.046Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.33px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.387,1.119L19.764,5.595",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.10955,0,0,1,-1.1984,3.24491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.141,4.991L7.141,-0.02L10.576,-0.02L10.576,0.828L8.152,0.828L8.152,2.014L10.244,2.014L10.244,2.862L8.152,2.862L8.152,4.991L7.141,4.991Z",
    style: {
      fill: "rgb(1,1,1)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.10955,0,0,1,-1.1984,9.51494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.141,4.991L7.141,-0.02L10.576,-0.02L10.576,0.828L8.152,0.828L8.152,2.014L10.244,2.014L10.244,2.862L8.152,2.862L8.152,4.991L7.141,4.991Z",
    style: {
      fill: "rgb(1,1,1)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.826473,0,0,1,0.839936,15.785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.12,4.991L7.12,-0.02L9.051,-0.02L9.562,1.687L10.025,-0.02L11.96,-0.02L11.96,4.991L10.835,4.991L10.835,1.047L10.229,2.991L8.883,2.991L8.317,1.047L8.317,4.991L7.12,4.991Z",
    style: {
      fill: "rgb(1,1,1)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.810231,0,0,1,2.36078,0.0290036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.832,9.816L17.422,9.816",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.1px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.06835,0,0,1,-0.929007,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.592,11.939L15.616,11.939",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.97px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.12082,0,0,1,-2.1765,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.107,11.939L18.014,11.939",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.94px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.782774,0,0,1,2.95255,8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.592,11.939L15.616,11.939",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.11px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.81208,0,0,1,-14.6287,8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.107,11.939L18.014,11.939",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.68px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.208925,0,0,1,10.7523,6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.592,11.939L15.616,11.939",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.38px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.97224,0,0,1,-35.5275,6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.107,11.939L18.014,11.939",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.45px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.278159,0,0,1,9.81127,2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.592,11.939L15.616,11.939",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.36px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.12082,0,0,1,-2.1765,2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.107,11.939L18.014,11.939",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.94px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.19477,0,0,1,-16.2393,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.592,11.939L15.616,11.939",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "0.59px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.0637227,0.0946884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.83,9.817L18.069,9.817",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2.32954,4.09469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.83,9.817L18.069,9.817",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfm);
export default __webpack_public_path__ + "static/media/ffm.9e6796be.svg";
export { ForwardRef as ReactComponent };